import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/platform/:id',
    name: 'platform',
    component: () => import('@/pages/Platform.vue'),
    meta: {
      requiresAuth: true,
      title: 'Платформа',
      layout: 'default'
    },
    props: true, // Передаем route.params как props,
  },
  {
    path: '/document/:id',
    name: 'document',
    component: () => import('@/pages/Platform.vue'),
    meta: {
      requiresAuth: true,
      title: 'Документ',
      layout: 'default'
    },
    props: true
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('@/pages/DeviceManagement.vue'),
    meta: {
      requiresAuth: true,
      title: 'Управление устройствами',
      layout: 'default'
    }
  },
] as RouteRecordRaw[]
